import { render, staticRenderFns } from "./AppAlert.vue?vue&type=template&id=91efb6e0&scoped=true"
import script from "./AppAlert.vue?vue&type=script&lang=ts"
export * from "./AppAlert.vue?vue&type=script&lang=ts"
import style0 from "./AppAlert.vue?vue&type=style&index=0&id=91efb6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91efb6e0",
  null
  
)

export default component.exports